module.exports = __webpack_public_path__ + "static/media/grey_style.bb01ab84.gif";